import React from "react";
import { motion } from "framer-motion";
import ProjectsCard from './ProjectsCard';
import { projectOne, projectFour, projectSeven} from "../../assets/index";
import RapportDeProjetCovid from '../../assets/reports/RapportDeProjetCovid.pdf';
import RapportProjetSondage from '../../assets/reports/RapportProjetSondage.pdf';
//import certificat_espagnol from '../../assets/reports/certificat_espagnol.pdf'

//import spanishCerfificate from '../../assets/reports/spanishCerfificate.pdf';

const DataAnalysis = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-6 font-titleFont flex flex-col gap-20 md:flex-row"
    >
      <div className="flex-1">
        <div className="py-6 font-titleFont flex flex-col gap-4">
          <h2 className="text-4xl font-bold">Data Analysis</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
            title="Cartographie du Taux de Criminalité en France par Département (Python - Streamlit)"

            des={`Ce projet combine l’analyse exploratoire de données et la visualisation interactive pour afficher les niveaux de risque criminel en France sous forme de carte dynamique.
              
              🔹 Technologies : Python, Pandas, Plotly, maplotlib, Jupyter Notebook, GeoJSON, Streamlit, Git
              `}

          src={projectSeven} /*image à mettre*/
            /*githubLink={}*/
            websiteLink="https://stat-delits.streamlit.app/"
          />
          
          <ProjectsCard
            title="Analyse et Visualisation des Données COVID-19 (Tableau Public)."
            des={`Ce projet analyse l’impact de la pandémie de COVID-19 à travers l'étude des tendances clés, facilitant l’analyse de l’évolution de la pandémie et l'impact de la vaccination.

              🔹 Technologies : Python, SQL, Tableau
              `}
         
            src={projectOne}
            githubLink="https://github.com/ChrisEssomba/Analyse-des-donnees-de-la-Covid-19"
            websiteLink={RapportDeProjetCovid}
            //websiteLink="https://public.tableau.com/app/profile/chris.essomba/viz/CovidDeathsVisualization_16845886904710/Tableaudebord1"
        
          />
          <ProjectsCard
            title="Analyse comparative de métiers de la Data (Power BI)."
            des={`Ce projet exploite les résultats d’un sondage auprès de professionnels de la data pour mieux comprendre les tendances en matière de salaires, de technologies, de formation et de secteurs dans le domaine de la data.

              🔹 Technologies : Excel (Power Query), Power BI, SQL
                `}
            
            src={projectFour}
            githubLink="https://github.com/ChrisEssomba/Analyse-de-Sondage"
            websiteLink={RapportProjetSondage}
          />
          {/*
          <ProjectsCard
            title="Tableau de Bord COVID-19 sur Tableau"
            des={`Ce tableau de bord offre une visualisation des informations essentielles issues des données de la pandémie de COVID-19. 
            Il met en évidence les tendances clés, facilitant l’analyse de l’évolution de la pandémie et de ses impacts."`}
            src={projectTwo}
            // githubLink={}
             websiteLink="https://public.tableau.com/app/profile/chris.essomba/viz/CovidDeathsVisualization_16845886904710/Tableaudebord1"

          />
          */}
       
      
        </div>
      </div>
    </motion.div>
  );
};

export default DataAnalysis;